export function convertToURL(productPath, homePath = '/downloads') {
  let path = homePath

  productPath.forEach(item => {
    path = `${path}/${encodeURIComponent(item)}`
  })

  return path;
}

export function compareByRankThenTitle(a, b) {
  if (a.rank < b.rank) {
    return -1
  }
  else if (a.rank > b.rank) {
    return 1;
  }
  else {
    if (a.title < b.title) {
      return -1;
    }
    else if (a.title > b.title) {
      return 1;
    }
    return 0;
  }
}


export function getSortedDocs(docs) {
  return docs.sort(compareByRankThenTitle)
}